var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194",
    transform: "translate(-77 -309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193",
    transform: "translate(78 310)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "secondary-upstroke",
    y2: 0.111,
    transform: "translate(15 5)",
    fill: "none",
    stroke: "#13b4c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "secondary-upstroke-2",
    "data-name": "secondary-upstroke",
    y2: 0.111,
    transform: "translate(10 5)",
    fill: "none",
    stroke: "#13b4c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "secondary-upstroke-3",
    "data-name": "secondary-upstroke",
    y2: 0.111,
    transform: "translate(5 5)",
    fill: "none",
    stroke: "#13b4c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "secondary-upstroke-4",
    "data-name": "secondary-upstroke",
    y1: 0.111,
    transform: "translate(15 10.444)",
    fill: "none",
    stroke: "#13b4c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "secondary-upstroke-5",
    "data-name": "secondary-upstroke",
    y1: 0.111,
    transform: "translate(10 10.444)",
    fill: "none",
    stroke: "#13b4c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "secondary-upstroke-6",
    "data-name": "secondary-upstroke",
    y1: 0.111,
    transform: "translate(5 10.444)",
    fill: "none",
    stroke: "#13b4c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "primary",
    width: 15.556,
    height: 20,
    rx: 1,
    transform: "translate(20) rotate(90)",
    fill: "none",
    stroke: "#102f74",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    x2: 9,
    transform: "translate(83.5 330)",
    fill: "none",
    stroke: "#102f74",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/screen.c3810fd70c36b3109459c0587e546f16.svg";
export { ForwardRef as ReactComponent };